<template>
  <div class="col-lg-3 theiaStickySidebar">
    <div class="settings-sidebar mb-lg-0">
      <div>
        <h6 class="mb-3">Main Menu</h6>
        <ul class="mb-3 pb-1">
          <li>
            <router-link
              to="/instructor/instructor-dashboard"
              class="d-inline-flex align-items-center"
              ><i class="isax isax-grid-35 me-2"></i>Dashboard</router-link
            >
          </li>
          <li>
            <router-link
              to="/instructor/instructor-profile"
              class="d-inline-flex align-items-center"
              ><i class="fa-solid fa-user me-2"></i>My Profile</router-link
            >
          </li>
          <li>
            <router-link
              to="/instructor/instructor-course"
              class="d-inline-flex align-items-center"
              ><i class="isax isax-teacher5 me-2"></i>Courses</router-link
            >
          </li>
          <!-- <li>
            <router-link
              to="/instructor/instructor-announcements"
              class="d-inline-flex align-items-center"
              ><i class="isax isax-volume-high5 me-2"></i>Announcements</router-link
            >
          </li> -->
          <!-- <li>
            <router-link
              to="/instructor/instructor-assignment"
              class="d-inline-flex align-items-center"
              ><i class="isax isax-clipboard-text5 me-2"></i>Assignments</router-link
            >
          </li> -->
          <li>
            <router-link
              to="/instructor/instructor-exam"
              class="d-inline-flex align-items-center"
              ><i class="isax isax-award5 me-2"></i>Exam</router-link
            >
          </li>
          <li>
            <router-link
              to="/instructor/instructor-recommendation"
              class="d-inline-flex align-items-center"
              ><i class="isax isax-medal-star5 me-2"></i>Learning Path</router-link
            >
          </li>
        </ul>
        <hr />
        <h6 class="mb-3">Account Settings</h6>
        <ul>
          <li>
            <button
              @click="handleLogout"
              class="btn btn-secondary d-inline-flex align-items-center justify-content-center w-100"
            >
              <i class="isax isax-logout me-2"></i>
              Logout
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { useAuthStore } from "@/stores/auth-store";

export default {
  setup() {
    const authStore = useAuthStore();
    return {
      authStore,
    };
  },
  data() {
    return {
      activeRoutes: [],
    };
  },
  computed: {
    isActiveRoute() {
      return this.activeRoutes.includes(this.$route.path);
    },
    dynamicRoute() {
      return this.activeRoutes[0];
    },
  },
  methods: {
    handleLogout() {
      this.authStore.logout();
      this.$router.push("/login");
    },
  },
};
</script>
